import React from 'react';
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, Role } from '@shared/hooks/useAuthStore';
import { hasNavAccess, landingPathForRole } from '@shared/utils/roleAccess';

interface Props {
  children: ReactNode;
  roles?: Role[];
}

export function ProtectedRoute({ children, roles }: Props): React.ReactElement {
  const location = useLocation();
  const { token, user } = useAuthStore();

  if (!token || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Gerarchia applicata (Admin/Dev includono gli specialisti). Chi non ha accesso
  // viene rimandato alla propria pagina di atterraggio, non a '/' (che potrebbe
  // essere anch'essa vietata e creare un rimbalzo).
  if (roles && roles.length > 0 && !hasNavAccess(user.role, roles)) {
    return <Navigate to={landingPathForRole(user.role)} replace />;
  }

  return <>{children}</>;
}
